import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bf-page" }
const _hoisted_2 = { class: "dashboard-charts" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardFilters = _resolveComponent("DashboardFilters")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_IntegrationsStats = _resolveComponent("IntegrationsStats")!
  const _component_IntegratedLines = _resolveComponent("IntegratedLines")!
  const _component_LineDivisionByIntegration = _resolveComponent("LineDivisionByIntegration")!
  const _component_RecentExecutions = _resolveComponent("RecentExecutions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: "Dashboard",
      subtitle: `Atualizado por último em ${_ctx.lastUpdated}`
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_DashboardFilters, { "last-updated": _ctx.lastUpdated }, null, 8, ["last-updated"])
      ]),
      _: 1
    }, 8, ["subtitle"]),
    _createVNode(_component_IntegrationsStats, {
      "is-loading": _ctx.isLoadingIntegrationDashboardInfo,
      data: _ctx.integrationDashboard
    }, null, 8, ["is-loading", "data"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_IntegratedLines, {
        "is-loading": _ctx.isLoadingIntegrationDashboardInfo,
        data: _ctx.integrationDashboard
      }, null, 8, ["is-loading", "data"]),
      _createVNode(_component_LineDivisionByIntegration, {
        "is-loading": _ctx.isLoadingIntegrationDashboardInfo,
        data: _ctx.integrationDashboard
      }, null, 8, ["is-loading", "data"])
    ]),
    _createVNode(_component_RecentExecutions)
  ]))
}